import * as colors from "./colors";

export const buttonStyle = {
  backgroundColor: colors.primary,
  borderRadius: "1.2em",
  padding: "1em 2em",
  display: "inline-block"
};
